import { Button } from '@navinc/base-react-components/wayfinder'

import { PLACEHOLDER_IMAGE_URL } from '../../const.js'
import { SmartLink } from '../SmartLink/SmartLink.jsx'

export type AuthorCardProps = {
  authorMedia?: {
    alt: string
    url: string | undefined
  } | null
  authorName: string
  authorDescription?: string | null
  authorBio?: string | null
  allArticlesUrl?: string | null
}

export const AuthorCard = ({
  authorMedia,
  authorName,
  authorDescription,
  authorBio,
  allArticlesUrl,
}: AuthorCardProps) => {
  const allArticlesButton = allArticlesUrl ? (
    <Button asChild className="w-full md:w-auto">
      <SmartLink to={allArticlesUrl}>All Articles</SmartLink>
    </Button>
  ) : null
  return (
    <div className="flex flex-col items-center gap-300 sm:flex-row sm:items-start md:gap-600">
      <div className="size-[206px] shrink-0 overflow-hidden rounded-200">
        {authorMedia?.url ? (
          <img className="size-full object-cover" alt={authorMedia.alt} src={authorMedia.url} />
        ) : (
          <img className="size-full object-cover" alt="" src={PLACEHOLDER_IMAGE_URL} />
        )}
      </div>
      <div className="flex w-full flex-col gap-200">
        <div className="flex items-start justify-between">
          <div className="flex flex-col gap-100">
            <h2 className="title1-emphasized text-onSurface">{authorName}</h2>
            {authorDescription && <p className="body2-emphasized text-onSurface">{authorDescription}</p>}
          </div>
          <div className="hidden sm:block">{allArticlesButton}</div>
        </div>
        {authorBio && <p className="body2">{authorBio}</p>}
      </div>
      <div className="w-full sm:hidden">{allArticlesButton}</div>
    </div>
  )
}
